import { Text, Alert } from 'braid-design-system';

const Disclaimer = () => (
  <Alert tone="info">
    <Text>
      The results from this price guide are based on SEEK Business data and
      should be used as an indication only. This is not a professional
      valuation. For further advice, consult a finance professional.
    </Text>
  </Alert>
);

export default Disclaimer;
